// Core
import { Route, Switch, Redirect, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { 
  Box, 
  Button, 
  Flex, 
  Text, 
  Grid, 
  Divider, 
  Image,
} from '@chakra-ui/react';

// Components
import SupportForm from './Form';
import SupportTickets from './Tickets';
import SupportTicketMessage from './Tickets/Livechat';
import CreateTicket from './Tickets/Create';

const Support = ({ userData }) => {
  const { path } = useRouteMatch();
  
  return (
    <>
      { userData ? (
        <Switch>
          <Route exact path="/contact-support/create-ticket" render={() => <CreateTicket userData={userData} />} />
          <Route 
            path={`${path}/:id`}  
            render={({ match }) => 
              /^\d+$/.test(match.params.id) ? <SupportTicketMessage userData={userData} /> : <Redirect to="/contact-support" />
            } 
          />
          <Route exact path="/contact-support" render={() => <SupportTickets userData={userData} />} />
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>

      ) : (
        <SupportForm />
      )}
    </>
  );
};

export default Support;